// JWT + impersonation persistence. Lives in localStorage so a hard refresh
// doesn't kick the user back to login. Split out from auth.tsx so the api
// client can read/clear the token without pulling in React.

const JWT_KEY = 'kiro_jwt';
const IMPERSONATOR_KEY = 'kiro_impersonator_email';
// Stash for the super-admin's JWT while impersonation is active. End-
// impersonation restores from here; without it, ending impersonation would
// drop the operator back to the login page.
const ORIGINAL_JWT_KEY = 'kiro_original_jwt';

export const getStoredJwt = (): string | null => {
  try {
    return localStorage.getItem(JWT_KEY);
  } catch {
    return null;
  }
};

export const setStoredJwt = (jwt: string): void => {
  try {
    localStorage.setItem(JWT_KEY, jwt);
  } catch {
    // localStorage may be unavailable in private mode — silently degrade
    // to in-memory-only auth. The user will need to sign in again on
    // refresh, which is acceptable for a private-window edge case.
  }
};

export const setImpersonator = (email: string): void => {
  try {
    localStorage.setItem(IMPERSONATOR_KEY, email);
  } catch {
    // see setStoredJwt
  }
};

export const getImpersonator = (): string | null => {
  try {
    return localStorage.getItem(IMPERSONATOR_KEY);
  } catch {
    return null;
  }
};

export const setOriginalJwt = (jwt: string): void => {
  try {
    localStorage.setItem(ORIGINAL_JWT_KEY, jwt);
  } catch {
    // see setStoredJwt
  }
};

export const getOriginalJwt = (): string | null => {
  try {
    return localStorage.getItem(ORIGINAL_JWT_KEY);
  } catch {
    return null;
  }
};

export const clearImpersonationState = (): void => {
  try {
    localStorage.removeItem(IMPERSONATOR_KEY);
    localStorage.removeItem(ORIGINAL_JWT_KEY);
  } catch {
    // see setStoredJwt
  }
};

export const clearStoredAuth = (): void => {
  try {
    localStorage.removeItem(JWT_KEY);
    localStorage.removeItem(IMPERSONATOR_KEY);
    localStorage.removeItem(ORIGINAL_JWT_KEY);
  } catch {
    // see setStoredJwt
  }
};
